import FrequentQuestions from './FrequentQuestions';

export default FrequentQuestions;
